import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import * as firebase from 'firebase'

import Styles from 'billing/common/Styles'

class PreviewHeader extends React.Component {

  static propTypes = {
    teamName: PropTypes.string.isRequired,
    uploadedCompanyLogo: PropTypes.bool,
    invoiceEditor: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.getCompanyLogoUrl()
  }
  
  getCompanyLogoStoragePath = () => {
    return `team_logo/${this.props.invoiceEditor.getTeamId()}/small_logo`
  }

  getCompanyLogoUrl = () => {
    firebase.storage().ref().child(this.getCompanyLogoStoragePath())
      .getDownloadURL()
      .then(companyLogoUrl => { this.setState({ companyLogoUrl }) })
  }

  render() {
    const customerInfo = this.props.invoiceEditor.getCustomerInfo()
    const contact = customerInfo && customerInfo.contact
    const contactName = contact && contact.contactName
    const address = contact && contact.address
    const email = contact && contact.email
    const phone = contact && contact.phone
    const date = this.props.invoiceEditor.getBillDate()
    const dateDisplay = date ? date.format('MMM Do, YYYY') : null
    const due = this.props.invoiceEditor.getPaymentDueDate()
    const dueDisplay = due ? due.format('MMM Do, YYYY') : null
    return (
      <div style={styles.container}>
        <div style={styles.row}>
          { this.props.uploadedCompanyLogo
            ? <img src={this.state.companyLogoUrl} width={121} height={121} />
            : <div style={Styles.noLogoBox}>Logo</div>
          }
          <div style={styles.companyInfo}>
            { this.props.teamName }
          </div>
        </div>
        <div style={{ ...styles.row, ...styles.secondRow }}>
          <div>
            <div style={styles.darkLabel()}>RECIPIENT</div>
            <div style={styles.grayLabel()}>{ contactName }</div>            
            <div style={styles.grayLabel(200)}>{ address }</div>
            <div style={styles.grayLabel()}>{ email }</div>
            <div style={styles.grayLabel()}>{ phone }</div>
          </div>
          <div style={styles.invoiceInfo}>
            <div style={styles.headerRightContainer}>
              <div style={styles.headerRightLabels}>
                <div style={styles.headerItem}>Invoice Number:</div>
                <div style={styles.headerItem}>Invoice Date:</div>
                <div style={styles.headerItem}>Payment Due:</div>
              </div>
              <div style={styles.headerRightData}>
                <div style={styles.headerItem}>{ this.props.invoiceEditor.getNumber() }</div>
                <div style={styles.headerItem}>{ dateDisplay }</div>
                <div style={styles.headerItem}>{ dueDisplay }</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fafafa',
    paddingTop: 48,
    paddingBottom: 48,
    paddingLeft: 32,
    paddingRight: 32
  },
  headerRightContainer: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 15
  },
  headerRightLabels: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    color: '#1f2229'
  },
  headerRightData: {
    color: '#828691',
    marginLeft: 8
  },
  headerItem: {
    marginBottom: 6
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  secondRow: {
    marginTop: 64
  },
  invoiceInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end'
  },
  darkLabel: fontSize => ({
    fontSize: fontSize || 14,
    color: '#1f2229'
  }),
  grayLabel: width => ({
    fontSize: 14,
    color: '#828691',
    marginTop: 6,
    width
  })
}

const mapStateToProps = state => ({
  teamName: state.firebase.team.metadata.value.displayName,
  uploadedCompanyLogo: state.firebase.team.metadata.value.uploadedCompanyLogo
})

export default connect(mapStateToProps)(PreviewHeader)



// WEBPACK FOOTER //
// ./src/billing/invoices/modules/header/PreviewHeader.js